import { useListContext } from "ra-core";
import { cn } from "@/lib/utils";

import { Task } from "./Task";
import { isDone, isRecentlyDone } from "./tasksPredicate";

export const TasksIterator = ({
  showContact,
  showOwner,
  hideDueDateWhenSingleDay,
  includeDone,
  className,
}: {
  showContact?: boolean;
  showOwner?: boolean;
  hideDueDateWhenSingleDay?: boolean;
  /** Set by the completed bucket, the one list whose point is done tasks. */
  includeDone?: boolean;
  className?: string;
}) => {
  const { data, error, isPending } = useListContext();
  if (isPending || error || data.length === 0) return null;

  // Keep only tasks that are not done or done less than 5 minutes ago. This is
  // the single place the grace window is applied: checking a task deliberately
  // does not invalidate the list query (see Task.tsx), so the row survives here
  // on the updated cache entry until it ages out.
  const tasks = includeDone
    ? data
    : data.filter((task) => !isDone(task) || isRecentlyDone(task));

  // A rule between rows, not a gap: two two-line rows eight pixels apart read
  // as one four-line paragraph, which is the "solid text" the list is accused
  // of. The rule gives the eye a repeating unit to lock onto, and the rows
  // carry their own vertical padding.
  //
  // `@container` is what lets a row lay itself out against the width of the
  // list it is in: the same row serves the full-width tasks page and a 300px
  // contact aside.
  return (
    <div className={cn("@container divide-y divide-border", className)}>
      {tasks.map((task) => (
        <Task
          task={task}
          showContact={showContact}
          showOwner={showOwner}
          hideDueDateWhenSingleDay={hideDueDateWhenSingleDay}
          key={task.id}
        />
      ))}
    </div>
  );
};
